// web/src/lib/external.ts — fetch helpers for the token-bearing /api/external/* routes.
// These intentionally do NOT include credentials/auth headers; routes are public + rate-limited.
// Uses relative paths (same origin) consistent with the rest of the SPA.
const base = "";

export interface ExternalTermsViewDto {
  companyName: string; accountReferenceNo: string;
  versionNumber: number; title: string; templateText: string; expiresOn: string;
}
export interface ExternalStatementViewDto {
  accountReferenceNo: string; statementNo: string;
  statementDate: string; periodFromDate: string; periodToDate: string;
  closingBalance: number; pdfDownloadUrl: string;
}
export interface AcceptTermsExternalRequest {
  acceptorName: string; position: string | null; signatureBase64Png: string | null;
}

export const externalApi = {
  getTerms: async (token: string): Promise<ExternalTermsViewDto> => {
    const r = await fetch(`${base}/api/external/account-terms/${encodeURIComponent(token)}`);
    if (!r.ok) throw new Error(r.status === 404 ? "Link not found or expired" : `HTTP ${r.status}`);
    return r.json();
  },
  acceptTerms: async (token: string, body: AcceptTermsExternalRequest): Promise<void> => {
    const r = await fetch(`${base}/api/external/account-terms/${encodeURIComponent(token)}/accept`, {
      method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body),
    });
    if (!r.ok) throw new Error(r.status === 410 || r.status === 404 ? "Link no longer valid" : `HTTP ${r.status}`);
  },
  getStatement: async (token: string): Promise<ExternalStatementViewDto> => {
    const r = await fetch(`${base}/api/external/account-statements/${encodeURIComponent(token)}`);
    if (!r.ok) throw new Error(r.status === 404 ? "Link not found or expired" : `HTTP ${r.status}`);
    return r.json();
  },
};
